import React, { useRef, useEffect, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import Page from "./Page";
import { images } from "./images";
import "./book.css";

const PortfolioBook: React.FC = () => {
    const bookRef = useRef<any>(null);
    const [bookSize, setBookSize] = useState({ width: 600, height: 800 });
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [loadingComplete, setLoadingComplete] = useState(false);

    const handleResize = () => {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const aspectRatio = 3 / 4;

        let width = windowHeight * aspectRatio;
        let height = windowHeight;

        if (width > windowWidth) {
            width = windowWidth;
            height = width / aspectRatio;
        }

        setBookSize({
            width: Math.floor(width),
            height: Math.floor(height),
        });
    };

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Loading images
    useEffect(() => {
        const loadImages = async () => {
            const total = images.length;
            let loaded = 0;

            const loadImage = (src: string): Promise<void> =>
                new Promise((resolve) => {
                    const img = new Image();
                    img.src = src;

                    img.onload = () => {
                        loaded++;
                        setLoadingProgress(Math.round((loaded / total) * 100));
                        resolve();
                    };

                    img.onerror = () => {
                        console.error(`Failed to load image: ${src}`);
                        loaded++;
                        setLoadingProgress(Math.round((loaded / total) * 100));
                        resolve(); // continue loading others even if one fails
                    };
                });

            await Promise.all(images.map(loadImage));
            setLoadingComplete(true);
        };

        loadImages();
    }, []);

    const bookKey = `${bookSize.width}-${bookSize.height}`;

    return (
        <div className="book-container">
            {!loadingComplete ? (
                <div className="loading">
                    <div>Welcome!</div>
                    <div>Portfolio is loading... {loadingProgress}%</div>
                    <div className="progress-bar">
                        <div className="progress-bar-filled" style={{ width: `${loadingProgress}%` }} />
                    </div>
                </div>
            ) : (
                <div className="container-html-flip-book">
                    <div className="author">Roxana Daroga Portfolio</div>
                    <HTMLFlipBook
                        key={bookKey}
                        ref={bookRef}
                        width={bookSize.width}
                        height={bookSize.height}
                        minWidth={bookSize.width}
                        minHeight={bookSize.height}
                        maxWidth={1000}
                        maxHeight={1400}
                        showCover={true}
                        mobileScrollSupport={true}
                        usePortrait={true}
                        className="portfolio-flip-book"
                        startPage={0}
                        flippingTime={1000}
                        clickEventForward={true}
                        showPageCorners={true}
                        disableFlipByClick={false}
                        autoSize={true}
                        maxShadowOpacity={0.5}
                        style={{}}
                        size="stretch"
                        drawShadow={true}
                        startZIndex={0} // 🔧 Adăugat pentru compatibilitate
                        useMouseEvents={true} // 🔧 Adăugat pentru compatibilitate
                        swipeDistance={30} // 🔧 Adăugat pentru compatibilitate
                    >
                        {images.map((img, index) => (
                            <Page key={index}>
                                <img src={img} className="page-image" />
                            </Page>
                        ))}
                    </HTMLFlipBook>
                </div>
            )}
        </div>
    );
};

export default PortfolioBook;
